import createStore from "astrid-helpers/src/createStore";
export const [getScrollOffset, setScrollOffset, useScrollOffset, onScrollOffset] = createStore([0, false]);
//# sourceMappingURL=scrollOffset.js.map